import { render } from "./GatewayReport.vue?vue&type=template&id=14ed61e6"
import script from "./GatewayReport.vue?vue&type=script&lang=js"
export * from "./GatewayReport.vue?vue&type=script&lang=js"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__